
export const ONBOARDING_APPLICATION_STATUS = {
    CREATED: "CREATED",
    IN_PROGRESS: "IN_PROGRESS",
    PROCESSING: "PROCESSING",
    IN_REVIEW: "IN_REVIEW",
    DECLINED: "DECLINED",
    COMPLETED: "COMPLETED",
}
export type onboardingApplicationStatusType = typeof ONBOARDING_APPLICATION_STATUS[keyof typeof ONBOARDING_APPLICATION_STATUS]

export const PAYMENT_ACCOUNT_STATUS = {
    PENDING: "PENDING",
    ONBOARDING: "ONBOARDING",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
    DEACTIVATED: "DEACTIVATED",
}
export type paymentAccountStatusType = typeof PAYMENT_ACCOUNT_STATUS[keyof typeof PAYMENT_ACCOUNT_STATUS]

export const SESSION_TYPE = {
    READ_PAYIN: "read_payin",
    READ_UPDATE_PAYIN: "read_update_payin",
    CREATE_PAYIN: "create_payin",
    CREATE_PAYMENT_METHOD: "create_payment_method",
    READ_DEPOSIT: "read_deposit",
    ONBOARDING_MERCHANT: "onboarding_merchant",
}
export type sessionType = typeof SESSION_TYPE[keyof typeof SESSION_TYPE]

export const PAYOUT_STATUS = {
    PROCESSING: "PROCESSING",
    SUCCEEDED: "SUCCEEDED", 
    FAILED: "FAILED",
    SUSPENDED: "SUSPENDED",
    INREVIEW: "IN_REVIEW",
}
export type payoutStatusType = typeof PAYOUT_STATUS[keyof typeof PAYOUT_STATUS]



// WEBPACK FOOTER //
// ./src/utils/payment-account/constants.ts